import * as React from "react";
const SvgFiBrandsAcrobat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-acrobat_svg__a)">
      <path d="M8.219 15.772c-1.04 1.64-2.015 2.689-2.615 2.689-.075 0-.225 0-.3-.075-.075-.15-.15-.3-.075-.45.075-.599 1.275-1.424 2.99-2.164M11.133 8.894c-.6-1.64-.525-2.84-.3-3.29a.41.41 0 0 1 .375-.225c.375 0 .45.45.45.825-.075.899-.225 1.865-.525 2.69M11.733 11.658c.372.67 1.04 1.413 1.342 1.78-.124-.01-1.348.264-2.317.609.375-.674.825-1.94.975-2.39M13.082 13.448l-.008-.009q.018.002.008.009M18.087 14.572c-.075.3-.45.6-1.125.45-.825-.225-1.565-.6-2.165-1.125.525-.075 1.79-.225 2.689-.075.301.075.676.3.601.75" />
      <path d="M19.736.3H4.264C1.865.3 0 2.165 0 4.554v14.882c0 2.39 1.94 4.254 4.264 4.264h15.472A4.26 4.26 0 0 0 24 19.436V4.564A4.26 4.26 0 0 0 19.736.3m-.356 14.703c-.141.375-.516.825-1.565.825-.75 0-2.249-.216-3.889-1.715-1.424.225-2.839.675-3.739.975-1.125 1.95-2.699 4.114-4.264 4.114-.375 0-.75-.075-1.05-.375-.3-.225-.45-.675-.375-1.05.225-1.35 2.84-2.54 4.039-2.99.89-1.564 1.64-3.58 2.09-4.928-.825-1.865-1.05-3.655-.525-4.554.225-.375.6-.6 1.05-.6 1.19 0 1.64 1.115 1.64 2.24 0 1.2-.3 2.465-.675 3.589.3.45 1.04 1.64 2.09 2.69.74-.075 3.805-.6 4.929.6.3.298.441.823.244 1.179" />
    </g>
    <defs>
      <clipPath id="fi-brands-acrobat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsAcrobat;
